import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { SVG } from '@base/icon/SVG';

export const IconPause: FC<IconProps> = props => (
    <SVG
        {...props}
        paths={[
            'M256 213.333333m42.666667 0l85.333333 0q42.666667 0 42.666667 42.666667l0 512q0 42.666667-42.666667 42.666667l-85.333333 0q-42.666667 0-42.666667-42.666667l0-512q0-42.666667 42.666667-42.666667Z',
            'M597.333333 213.333333m42.666667 0l85.333333 0q42.666667 0 42.666667 42.666667l0 512q0 42.666667-42.666667 42.666667l-85.333333 0q-42.666667 0-42.666667-42.666667l0-512q0-42.666667 42.666667-42.666667Z'
        ]}
    />
);